import { User } from '@auth0/auth0-react';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
    auth0User?: User;
    bearerToken?: string;
    idToken?: string;
}

const initialState: AuthState = {
    auth0User: undefined,
    idToken: undefined,
    bearerToken: undefined,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setBearerToken: (state, action: PayloadAction<string | undefined>) => {
            state.bearerToken = action.payload;
        },
        setIdToken: (state, action: PayloadAction<string | undefined>) => {
            state.idToken = action.payload;
        },
        setAuth0User: (state, action: PayloadAction<User | undefined>) => {
            state.auth0User = action.payload;
        },
    },
    selectors: {
        selectBearerToken: (authState: AuthState) => authState.bearerToken,
        selectIsAuthenticated: (authState: AuthState) => !!authState.bearerToken,
        selectAuth0User: (authState: AuthState) => authState.auth0User,
        selectAuth0UserId: (authState: AuthState) => authState.auth0User?.user_id,
    },
});

export const { setBearerToken, setIdToken, setAuth0User } = authSlice.actions;

export const { selectBearerToken, selectIsAuthenticated, selectAuth0User, selectAuth0UserId } =
    authSlice.selectors;

export default authSlice.reducer;
